module.exports = __webpack_public_path__ + "static/media/logo-icon.68fad2eb.png";